import styled from 'styled-components';
import { font, breakpoints, spacing } from '@chegg-ui/theme';
export var PricePerDayWrapper = styled.div.withConfig({
  componentId: "sc-1ybst1h-0"
})(["font-family:", ";font-size:", ";font-style:normal;font-weight:", ";line-height:130%;@media (max-width:", "){margin-top:", ";font-size:", ";}"], font.family.aspira, font.size.px22, font.weight.normal, breakpoints.md.max, spacing.px24, font.size.px20);
export var PricePerDayValue = styled.span.withConfig({
  componentId: "sc-1ybst1h-1"
})(["font-weight:", ";"], font.weight.bold);
export var PricePerDaySubtext = styled.span.withConfig({
  componentId: "sc-1ybst1h-2"
})(["@media (max-width:", "){display:block;font-size:", ";}"], breakpoints.md.max, font.size.px16);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/PricePerDay/styled.js
// module id = 4014
// module chunks = 11